var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTimesIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2968",
    "data-name": "Rectangle 2968",
    width: 20,
    height: 20,
    fill: "#e6f0f3"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10614",
    "data-name": "Group 10614",
    transform: "translate(0.041)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10613",
    "data-name": "Group 10613",
    transform: "translate(-0.041)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_28428",
    "data-name": "Path 28428",
    d: "M7.317,8.979a1,1,0,0,0,0,2H10.31a1,1,0,0,0,1-1V4.989a1,1,0,0,0-2,0V8.979ZM9.977,0a9.977,9.977,0,1,0,9.977,9.977A9.979,9.979,0,0,0,9.977,0m0,17.959a7.982,7.982,0,1,1,7.982-7.982,7.985,7.985,0,0,1-7.982,7.982",
    transform: "translate(0.046)",
    fill: "#e6f0f3"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimesIcon);
export default __webpack_public_path__ + "static/media/times_icon.57c20705d1fc4566aaefd9a141c68522.svg";
export { ForwardRef as ReactComponent };